import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LeasingCriteria } from './models/leasingCriteria';
import { ILeasingSearchResult } from './models/leasingSearchResult';

@Component({
    templateUrl: './summaryDialog.component.html',
    styleUrls: ['./modal.css', './summaryDialog.component.css'],
    standalone: false
})
export class SummaryDialogComponent implements OnInit {

    leasingCriteria: LeasingCriteria;
    searchResult: ILeasingSearchResult;

    constructor(public dialogRef: MatDialogRef<SummaryDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.leasingCriteria = data.leasingComponent.leasingCriteria;
        this.searchResult = data.leasingComponent.searchResult;
    }

    ngOnInit(): void {
        // nothing to initialize yet
    }

    close(): void {
        this.dialogRef.close();
    }

}
